import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import SubscriptionTypes from './SubscriptionTypes';
import { setGatewayProperty, setSpecificGatewayIdProperty, setCustomerProperty, cancelVippsAgreement } from '../Networking/APIClient';
import Typography from '@material-ui/core/Typography';
import UpdateIcon from '@material-ui/icons/Update';
import InfoIcon from '@material-ui/icons/Info';
import LockIcon from '@material-ui/icons/Lock';
import HowToRegIcon from '@material-ui/icons/HowToReg';
import Button from '@material-ui/core/Button';
import UpdateCardDialog from './UpdateCardDialog';
import ConfirmDialog from './ConfirmDialog';
import { getTerms } from './Terms';
import { getPrivacyPolicy } from './PrivacyPolicy';
import VippsPaymentInformationDialog from './VippsPaymentInformationDialog';
import { GatewayReplaceIcon } from '../Assets/Icons/Sikom';

const CustomTableCell = withStyles(theme => ({
    head: {
        backgroundColor: '#808080',
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const styles = theme => ({
    root: {
        overflowX: 'auto',
    },
    table: {
        width: '100%',
    },
    headerRow: {
        width: '100%',
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.background.default,
        },
    },
});

let t;
let self;

class SubscriptionGateway extends React.Component {
    constructor(props) {
        super(props);
        t = props.t;
        self = this;
        this.state = {
            updateCardDialogOpen: false,
            cardDeletedDialogOpen: false,
            cardDeletionFailedDialogOpen: false,
            termsDialogOpen: false,
            privacyPolicyDialogOpen: false,
            vippsPaymentInformationDialogOpen: false,
            vippsSubscriptionCanceledDialogOpen: false,
            vippsSubscriptionCancellationFailedDialogOpen: false,
        }
    }

    generateUpdateCardInformationDialog() {
        const updateCardDialog =
            <UpdateCardDialog
                deleteCardAndDisableAutomaticRenewal={this.deleteCardAndDisableAutomaticRenewal}
                automaticRenewalWillBeDone={this.props.gateway.subscription_automatic_renewal_will_be_done === '1' ? true : false}
                automaticLogin={this.props.automaticLogin}
                language={this.props.language}
                setLoading={this.props.setLoading}
                onTermsAccepted={this.onTermsAccepted}
                t={t}
                toggleDialog={this.toggleUpdateDialog}
                open={this.state.updateCardDialogOpen}
                updatePage={this.props.updatePage} />
        return updateCardDialog;
    }

    generateVippsPaymentInformationDialog() {
        const vippsPaymentInformationDialog =
            <VippsPaymentInformationDialog
                cancelVippsSubscriptionAndDisableAutomaticRenewal={this.cancelVippsSubscriptionAndDisableAutomaticRenewal}
                automaticRenewalWillBeDone={this.props.gateway.subscription_automatic_renewal_will_be_done === '1' ? true : false}
                automaticLogin={this.props.automaticLogin}
                language={this.props.language}
                setLoading={this.props.setLoading}
                t={t}
                credentials={this.props.credentials}
                customer={this.props.customer}
                toggleDialog={this.toggleVippsPaymentInformationDialog}
                customerIsRegistered={this.props.customerIsRegistered}
                open={this.state.vippsPaymentInformationDialogOpen} />
        return vippsPaymentInformationDialog
    }

    generatePrivacyPolicyDialog() {
        const privacyPolicyDialog =
            <ConfirmDialog
                titleText={t('privacy_policy')}
                messageText={getPrivacyPolicy(this.props.language)}
                buttonText={t('ok')}
                onButtonClicked={e => this.onPrivacyPolicyOkButtonClicked(e)}
                open={this.state.privacyPolicyDialogOpen} />
        return privacyPolicyDialog;
    }

    generateTermsDialog() {
        const termsDialog =
            <ConfirmDialog
                titleText={t('subscription_terms')}
                messageText={getTerms(this.props.language)}
                buttonText={t('ok')}
                onButtonClicked={e => this.onTermsOkButtonClicked(e)}
                open={this.state.termsDialogOpen} />
        return termsDialog;
    }

    //NETS stuff
    toggleUpdateDialog() {
        self.setState((prevState) => ({
            updateCardDialogOpen: !prevState.updateCardDialogOpen
        }));
    }


    toggleCardDeletedDialog() {
        self.setState((prevState) => ({
            cardDeletedDialogOpen: !prevState.cardDeletedDialogOpen
        }));
    }

    toggleCardDeletionFailedDialog() {
        self.setState((prevState) => ({
            cardDeletionFailedDialogOpen: !prevState.cardDeletionFailedDialogOpen
        }));
    }

    deleteCardAndDisableAutomaticRenewal = e => {
        e.preventDefault();

        let renewalDisabled = false;
        let maskedPanDeleted = false;
        let expiryDateDeleted = false;
        let panHashDeleted = false;
        let errorDialogShown = false;

        function checkAllOk() {
            if (renewalDisabled && maskedPanDeleted && expiryDateDeleted && panHashDeleted) {
                // Update app data
                self.props.updateAppData();
                self.props.setLoading(false);
                self.toggleCardDeletedDialog();
            }
        }

        const onRenewalModeDisabled = function onRenewalModeDisabled() {
            renewalDisabled = true;
            checkAllOk();
        };

        const onMaskedPanDeleted = function onMaskedPanDeleted() {
            maskedPanDeleted = true;
            checkAllOk();
        };

        const onExpiryDateDeleted = function onExpiryDateDeleted() {
            expiryDateDeleted = true;
            checkAllOk();
        };

        const onPanHashDeleted = function onPanHashDeleted() {
            panHashDeleted = true;
            checkAllOk();
        };

        const onError = function onError() {
            /*
            This may trigger several times, which is redundant and which also opens and closes
            the dialog each time. The errorDialogShown flag makes sure this only happens once.
            */
            if (!errorDialogShown) {
                console.log("Could not delete all credit card information");
                self.props.updateAppData();
                self.props.setLoading(false);
                self.toggleCardDeletionFailedDialog();
                errorDialogShown = true;
            }
        };
        setGatewayProperty(this.props.usingValueCode, this.props.credentials, 'subscription_automatic_renewal_mode', '0', this.props.credentials.email, onRenewalModeDisabled, onError);
        setCustomerProperty(this.props.usingValueCode, this.props.credentials, 'payment_masked_pan', ' ', this.props.credentials.email, onMaskedPanDeleted, onError);
        setCustomerProperty(this.props.usingValueCode, this.props.credentials, 'payment_credit_card_expiry_date', ' ', this.props.credentials.email, onExpiryDateDeleted, onError);
        setCustomerProperty(this.props.usingValueCode, this.props.credentials, 'payment_pan_hash', ' ', this.props.credentials.email, onPanHashDeleted, onError);
    }

    onUpdateCardClicked = e => {
        e.preventDefault();
        self.setState({
            updateCardDialogOpen: true
        })
    }

    onPrivacyPolicyClicked = e => {
        e.preventDefault();
        this.setState({
            privacyPolicyDialogOpen: true
        });
    }

    onPrivacyPolicyOkButtonClicked = e => {
        e.preventDefault();
        this.setState({
            privacyPolicyDialogOpen: false
        });
    }

    onTermsClicked = e => {
        e.preventDefault();
        this.setState({
            termsDialogOpen: true
        });
    }

    onTermsOkButtonClicked = e => {
        e.preventDefault();
        this.setState({
            termsDialogOpen: false
        });
    }

    onAllSubscriptionsClicked = e => {
        e.preventDefault();
        window.scrollTo(0, 0)
        this.props.updatePage('subscription')
    }

    toggleVippsPaymentInformationDialog() {
        self.setState((prevState) => ({
            vippsPaymentInformationDialogOpen: !prevState.vippsPaymentInformationDialogOpen
        }));
    }

    toggleVippsSubscriptionCanceledDialog() {
        self.setState((prevState) => ({
            vippsSubscriptionCanceledDialogOpen: !prevState.vippsSubscriptionCanceledDialogOpen
        }));
    }

    toggleVippsSubscriptionCancellationFailedDialog() {
        self.setState((prevState) => ({
            vippsSubscriptionCancellationFailedDialogOpen: !prevState.vippsSubscriptionCancellationFailedDialogOpen
        }));
    }
    // toggleVippsSubscriptioCanceledDialog()/CancellationFailedDialog() aren't working properly in SAM within Sikom Living.
    closeVippsSubscriptionCanceledDialog = e => {
        e.preventDefault();
        self.setState({
            vippsSubscriptionCanceledDialogOpen: false
        });
    }

    closeVippsSubscriptionCancellationFailedDialog = e => {
        e.preventDefault();
        self.setState({
            vippsSubscriptionCancellationFailedDialogOpen: false
        });
    }

    // Cancels Vipps subscription and disables automatic renewal
    cancelVippsSubscriptionAndDisableAutomaticRenewal(credentials) {
        self.props.setLoading(true);

        let renewalDisabled = false;
        let vippsAgreementCanceled = false;
        let errorDialogShown = false;
        let hasMultipleGateways;

        function checkAllOk() {
            if (renewalDisabled && vippsAgreementCanceled) {
                // Update app data
                self.props.updateAppData();
                self.props.setLoading(false);
                self.toggleVippsSubscriptionCanceledDialog();
            }
        }

        const onRenewalModeDisabled = function onRenewalModeDisabled() {
            renewalDisabled = true;
            checkAllOk();
        };

        const onVippsAgreementCanceled = function onVippsAgreementCanceled() {
            vippsAgreementCanceled = true;

            hasMultipleGateways = self.props.hasMultipleGateways;
            if (hasMultipleGateways) {
                setSpecificGatewayIdProperty(self.props.usingValueCode, credentials, 'subscription_automatic_renewal_mode', '0', credentials.email, self.props.gateway.bpapi_gateway_id, onRenewalModeDisabled, onError);
            }
            else {
                setGatewayProperty(self.props.usingValueCode, self.props.credentials, 'subscription_automatic_renewal_mode', '0', self.props.credentials.email, onRenewalModeDisabled, onError);
            }

            checkAllOk();
        };

        const onError = function onError() {
            /*
            This may trigger several times, which is redundant and which also opens and closes
            the dialog each time. The errorDialogShown flag makes sure this only happens once.
            */
            if (!errorDialogShown) {
                console.log("Could not cancel vipps recurring payment");
                self.props.updateAppData();
                self.props.setLoading(false);
                self.toggleVippsSubscriptionCancellationFailedDialog();
                errorDialogShown = true;
            }
        };
        cancelVippsAgreement(credentials, self.props.gateway.bpapi_gateway_id, onVippsAgreementCanceled, onError);

    }

    onVippsPaymentInformationClicked = e => {
        e.preventDefault();
        self.setState({
            vippsPaymentInformationDialogOpen: true
        })
    }

    onReplaceGatewayClicked(chosenGateway, e) {
        e.preventDefault();
        self.props.setGatewayToBeReplaced(chosenGateway);
        window.scrollTo(0, 0);
        this.props.updatePage('replace_gateway');
    }

    checkIfGatewayShouldBeReplaced(gateway) {
        switch (gateway.gateway_type) {
            case 'CTMmTouchHub':
            case 'SikomLANECOComfort':
            case 'GSMFixiPlus4G':
            case 'GSMECOComfort4G':
            case 'GSMECOController4G':
            case 'GSMECOComfort3':
            case 'GSMECOController3':
                return gateway.subscription_type === 'Trial' ? false : false;
            default:
                return gateway.subscription_type === 'Trial' ? false : true;
        }
    }

    render() {
        const { classes } = this.props;
        const gateway = this.props.gateway;
        const customer = this.props.customer;
        /*
        if (this.state.renewalDialogOpen) {
            dialog = <DisableAutomaticRenewalDialog
                usingValueCode={this.props.usingValueCode}
                updateAppData={this.props.updateAppData}
                credentials={this.props.credentials}
                automaticRenewal={this.props.gateway.subscription_automatic_renewal_mode === '1' ? true : false}
                t={t}
                toggleDialog={this.toggleRenewalDialog}
                open={this.state.renewalDialogOpen} />
        } else 
        */

        // On the AccountOverview page, we do not show a checkbox. Just a text.

        const gatewayTable =
            <div>
                <Paper className={classes.root} key={gateway.bpapi_gateway_id}>
                    <Table className={classes.table}>
                        <TableBody>
                            <TableRow className={classes.row}>
                                <CustomTableCell component="th" scope="row">{t('gateway_name')}</CustomTableCell>
                                <CustomTableCell >{gateway.best_effort_name}</CustomTableCell>
                            </TableRow>
                            <TableRow className={classes.row}>
                                <CustomTableCell component="th" scope="row">{t('value_code')}</CustomTableCell>
                                <CustomTableCell >{gateway.value_code}</CustomTableCell>
                            </TableRow>
                            <TableRow className={classes.row}>
                                <CustomTableCell component="th" scope="row">{t('gateway_type')}</CustomTableCell>
                                <CustomTableCell >{gateway.product_friendly_name}</CustomTableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    {this.checkIfGatewayShouldBeReplaced(gateway) ?
                        <Button
                            onClick={e => this.onReplaceGatewayClicked(gateway.value_code, e)}
                            style={buttonStyle}
                            variant="outlined"
                            color="secondary">
                            <GatewayReplaceIcon style={buttonIconStyle} />
                            {t('replace_gateway')}
                        </Button> : null}
                </Paper >
            </div>;

        const currentSubscriptionTable =
            <div key={gateway.bpapi_gateway_id}>
                <Paper className={classes.root} key={gateway.bpapi_gateway_id}>
                    <Table className={classes.table}>
                        <TableBody>
                            <TableRow className={classes.row}>
                                <CustomTableCell component="th" scope="row">{t('type')}</CustomTableCell>
                                <CustomTableCell >{t(gateway.subscription_type)}</CustomTableCell>
                            </TableRow>
                            <TableRow className={classes.row}>
                                <CustomTableCell component="th" scope="row">{t('days_remaining')}</CustomTableCell>
                                <CustomTableCell >{gateway.subscription_days_remaining}</CustomTableCell>
                            </TableRow>
                            <TableRow className={classes.row}>
                                <CustomTableCell component="th" scope="row">{t('automatic_renewal')}</CustomTableCell>
                                {/*Todo: Maybe add an info button giving information on why automatic renewal will not be done Can subscription_description be used here?*/}
                                <CustomTableCell >{gateway.subscription_automatic_renewal_will_be_done === '1' ? t('yes') : t('no')}</CustomTableCell>
                            </TableRow>
                            {customer.latest_receipt_url != null ?
                                <TableRow className={classes.row}>
                                    <CustomTableCell component="th" scope="row">{t('latest_receipt')}</CustomTableCell>
                                    <CustomTableCell >
                                        <a href={customer.latest_receipt_url} target="_blank">{t('show_receipt')}</a>
                                    </CustomTableCell>
                                </TableRow> : null}
                            {/*Show payment type only when paid with Vipps */}
                            {(gateway.vipps_agreement_id != null && gateway.vipps_agreement_id != '') && gateway.subscription_automatic_renewal_will_be_done === '1' ?
                                <TableRow className={classes.row}>
                                    <CustomTableCell component="th" scope="row">{t('payment_type')}</CustomTableCell>
                                    <CustomTableCell >Vipps</CustomTableCell>
                                </TableRow> : null}
                            {gateway.vipps_agreement_id === '' && customer.payment_masked_pan != '' && gateway.subscription_automatic_renewal_will_be_done === '1' ?
                                <TableRow className={classes.row}>
                                    <CustomTableCell component="th" scope="row">{t('card_number')}</CustomTableCell>
                                    <CustomTableCell >{customer.payment_masked_pan}</CustomTableCell>
                                </TableRow> : null}
                            {gateway.vipps_agreement_id === '' && customer.payment_credit_card_expiry_date != '' && gateway.subscription_automatic_renewal_will_be_done === '1' ?
                                <TableRow className={classes.row}>
                                    <CustomTableCell component="th" scope="row">{t('expiry_date')}</CustomTableCell>
                                    <CustomTableCell >{customer.payment_credit_card_expiry_date}</CustomTableCell>
                                </TableRow> : null}
                        </TableBody>
                    </Table>
                    {/* Show update card information-button only if the subscription is not a Trial, Vipps Payment Information if vipps_agreement_id is not empty */}
                    {(gateway.subscription_type != 'Trial' && customer.payment_masked_pan != '' && gateway.vipps_agreement_id === '') ?
                        <Button
                            onClick={e => this.onUpdateCardClicked(e)}
                            style={buttonStyle}
                            variant="contained"
                            color="primary">
                            <UpdateIcon style={buttonIconStyle} />
                            {t('update_card_information')}
                        </Button > : null}
                    {(gateway.subscription_type != 'Trial' && (gateway.vipps_agreement_id != null && gateway.vipps_agreement_id != '')) ?
                        <Button
                            onClick={e => this.onVippsPaymentInformationClicked(e)}
                            style={buttonStyle}
                            variant="contained"
                            color="primary">
                            <UpdateIcon style={buttonIconStyle} />
                            {t('manage_vipps_payments_title')}
                        </Button > : null}
                </Paper >
            </div>;

        const termsContent =
            <div>
                <Button
                    onClick={e => this.onPrivacyPolicyClicked(e)}
                    style={buttonStyle}
                    variant="outlined"
                    color="secondary">
                    <LockIcon style={buttonIconStyle} />
                    {t('show_privacy_policy')}
                </Button >
                <br />
                <br />
                <Button
                    onClick={e => this.onTermsClicked(e)}
                    style={buttonStyle}
                    variant="outlined"
                    color="secondary">
                    <HowToRegIcon style={buttonIconStyle} />
                    {t('show_terms')}
                </Button >
            </div>;

        const allSubscriptionsLink = <a href="https://www.sikom.no/sikom-living/abonnementspriser/" target="_blank">{t('our_sites')}</a>;

        return (
            <div>
                {this.state.updateCardDialogOpen ? this.generateUpdateCardInformationDialog() : null}
                {this.state.vippsPaymentInformationDialogOpen ? this.generateVippsPaymentInformationDialog() : null}
                {this.state.termsDialogOpen ? this.generateTermsDialog() : null}
                {this.state.privacyPolicyDialogOpen ? this.generatePrivacyPolicyDialog() : null}

                {/*Success Card*/}
                <ConfirmDialog
                    titleText={t('card_deleted_title')}
                    messageText={t('card_deleted_message')}
                    buttonText={t('ok')}
                    onButtonClicked={e => this.toggleCardDeletedDialog(e)}
                    open={this.state.cardDeletedDialogOpen} />
                {/*Success Vipps*/}
                <ConfirmDialog
                    titleText={t('vipps_payments_stopped_title')}
                    messageText={t('vipps_payments_stopped_message')}
                    buttonText={t('ok')}
                    onButtonClicked={e => this.closeVippsSubscriptionCanceledDialog(e)}
                    open={this.state.vippsSubscriptionCanceledDialogOpen} />
                {/*Failure Card*/}
                <ConfirmDialog
                    titleText={t('card_deletion_failed_title')}
                    messageText={t('card_deletion_failed_message')}
                    buttonText={t('ok')}
                    onButtonClicked={e => this.toggleCardDeletionFailedDialog(e)}
                    open={this.state.cardDeletionFailedDialogOpen} />
                {/*Failure Vipps*/}
                <ConfirmDialog
                    titleText={t('vipps_cancellation_failed_title')}
                    messageText={t('vipps_cancellation_failed_message')}
                    buttonText={t('ok')}
                    onButtonClicked={e => this.closeVippsSubscriptionCancellationFailedDialog(e)}
                    open={this.state.vippsSubscriptionCancellationFailedDialogOpen} />
                {gatewayTable}
                <div className='typography-title-container'>
                    <Typography variant="title">
                        {t('current_subscription')}
                    </Typography>
                </div>
                {currentSubscriptionTable}
                <div className='typography-title-container'>
                    <Typography variant="title">
                        {t('update_subscription')}
                    </Typography>
                </div>
                <SubscriptionTypes
                    updatePage={this.props.updatePage}
                    setLoading={this.props.setLoading}
                    language={this.props.language}
                    automaticLogin={this.props.automaticLogin}
                    simpleView={this.props.simpleView}
                    credentials={this.props.credentials}
                    customer={this.props.customer}
                    gateway={this.props.gateway}
                    hasMultipleGateways={this.props.hasMultipleGateways}
                    t={t}
                    setShouldRenewSubscription={this.props.setShouldRenewSubscription}
                    shouldRenewSubscription={this.props.shouldRenewSubscription}
                    updatePageWithProps={this.props.updatePageWithProps}
                    logout={this.props.logout} />
                {this.props.simpleView ?
                    <div>
                        <div className="recommended-subscription-action-help-container">
                            <Typography variant="body2">
                                {t('sam_compare_subscription_text_1')} {allSubscriptionsLink}.
                            </Typography>
                        </div>
                    </div>
                    : null}
                {this.props.simpleView ? null :
                    <div>
                        <div className='typography-title-container'>
                            <Typography variant="title">
                                {t('terms') + ' ' + t('for') + ' ' + t('subscription')}
                            </Typography>
                        </div>
                        {termsContent}
                    </div>
                }
            </div>
        );
    }
}

SubscriptionGateway.propTypes = {
    classes: PropTypes.object.isRequired,
};

const buttonStyle = {
    width: '100%'
};

const allSubscriptionsButtonStyle = {
    width: '100%',
    marginTop: 10
};

const buttonIconStyle = {
    paddingRight: 10,
};

export default withStyles(styles)(SubscriptionGateway);


// WEBPACK FOOTER //
// ./src/Components/SubscriptionGateway.js